import React, { FC } from 'react'
import { Center, Divider, HStack, Typography, VStack, XelaColor } from '@/XelaReact'
import { useDispatch, useSelector } from 'react-redux'
import { motion } from 'framer-motion'
import { router, usePage } from '@inertiajs/react'
import { RootState } from '@/Store'
import { Box, UnstyledButton } from '@mantine/core'
import { toggleHubSettingSubSidebar } from '@/Store/globalSlice'
import { IconChevronLeft, IconDatabase, IconUserCircle, IconUsers } from '@tabler/icons-react'
import useAuth from '@/Hooks/useAuth'

const HubSettingsSubSidebar: FC = () => {
  const page = usePage()
  const auth = useAuth()
  const dispatch = useDispatch()
  const globalStore = useSelector((state: RootState) => state.global)

  const tabItems = []

  {
    if (auth.role.role_key === 'admin') {
      tabItems.push({
        label: 'Agency Details',
        route: '/hub/settings/agency-details',
        icon: <IconDatabase width="20" height="20" color={XelaColor.Blue5} />,
      })

      tabItems.push({
        label: 'Team Management',
        route: '/hub/settings/team-management',
        icon: <IconUsers width="20" height="20" color={XelaColor.Blue5} />,
      })
    }

    tabItems.push({
      label: 'Change Password',
      route: '/hub/settings/personal-details',
      icon: <IconUserCircle width="20" height="20" color={XelaColor.Blue5} />,
    })
  }

  return (
    <motion.div
      className={`${
        globalStore.isHubSettingsSubSidebarOpen ? 'w-60 block' : 'hidden'
      } z-10 absolute bg-white min-h-screen top-0`}
      initial={{ opacity: 0.5, x: 0 }}
      animate={{ opacity: 1, x: globalStore.isSidebarOpen ? 230 : 65 }}
      transition={{ duration: 0.25 }}
    >
      <div>
        <VStack
          bg={XelaColor.White}
          spacing="12px"
          justifyContent="flex-start"
          height="100vh"
          className="shadow py-8 px-4 overflow-auto"
        >
          <HStack justifyContent={globalStore.isHubSettingsSubSidebarOpen ? 'space-between' : 'center'}>
            <VStack spacing="4px">
              <HStack justifyContent={globalStore.isHubSettingsSubSidebarOpen ? 'space-between' : 'center'}>
                <Typography variant={'subheadline'} color={XelaColor.Blue3}>
                  Settings
                </Typography>
                <UnstyledButton
                  className={'hover:bg-blue-50 p-1 rounded-full ease-in-out delay-50'}
                  onClick={() => {
                    dispatch(toggleHubSettingSubSidebar(false))
                  }}
                >
                  <IconChevronLeft size={20} />
                </UnstyledButton>
              </HStack>
            </VStack>
          </HStack>
          <Divider variant="dotted" />
          <VStack spacing="8px">
            {tabItems.map((item, index) => (
              <Box
                key={index}
                onClick={() => {
                  dispatch(toggleHubSettingSubSidebar(!globalStore.isHubSettingsSubSidebarOpen))
                  router.visit(`${item.route}`)
                }}
                style={
                  page.url === item.route
                    ? {
                        padding: '8px',
                        backgroundColor: XelaColor.Blue12,
                        borderRadius: '12px',
                        width: '100%',
                      }
                    : {
                        padding: '8px',
                      }
                }
                className="flex space-x-4 w-full px-2 py-3 cursor-pointer hover:bg-blue-12 rounded-lg"
              >
                <Center width="18px" height="18px" style={{ minWidth: '24px' }}>
                  {item.icon}
                </Center>
                <Box className="flex justify-between w-full">
                  <Typography variant="body-small-bold">{item.label}</Typography>
                </Box>
              </Box>
            ))}
          </VStack>
        </VStack>
      </div>
    </motion.div>
  )
}

export default HubSettingsSubSidebar
